import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const proformaIssueFormsDirectEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-proforma-issue-forms-direct-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
